import { Link } from 'react-router';
import { RiInformationLine } from 'react-icons/ri';
import { Tooltip } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { appColors } from '@/const';
import { IntlMessages } from '@/components';
import styles from './DocumentationTooltip.module.css';

const DocumentationTooltip = ({ link = '#', message = '' }) => {
  return (
    <Tooltip
      className={styles.wrapper}
      placement="top"
      title={
        <>
          <IntlMessages id="ui-general-doc-link-notification" />
          &nbsp;
          <Link style={{ color: appColors.blueLink }} to={link} target="_blank">
            https://x-flow-ltd.atlassian.net/wiki/...
          </Link>
        </>
      }
    >
      <RiInformationLine size={16} fill="blue" className={styles.icon} />
    </Tooltip>
  );
};

DocumentationTooltip.propTypes = {
  link: PropTypes.string,
  message: PropTypes.string,
};

export default DocumentationTooltip;
